import { CanDeactivateFn } from '@angular/router';
import { CustomerFormComponent } from './customer-form.component';

export const canDeactivateCustomerForm: CanDeactivateFn<CustomerFormComponent> = (component) => {
  if (component.hasUnsavedChanges()) {
    return component.confirmDeactivate();
  }
  return true;
};
